/**
 * Money rounding + parsing primitives — shared client/server (Wave 1).
 *
 * One implementation of the two helpers every money path leans on. These
 * were previously duplicated as quote-pricing's roundMoney/toFiniteMoney,
 * quote-discount's round2, and deposit-config's roundToCents (both sides) —
 * penny-identical by hand-maintained luck; now by construction.
 */

/**
 * Round to cents (2dp) with a finite guard — NaN/Infinity round to 0 so
 * corrupt input can't poison a total. Math.round(n * 100) / 100, the exact
 * formula every prior copy used.
 */
export function roundMoney(n: number): number {
  if (!Number.isFinite(n)) return 0;
  return Math.round(n * 100) / 100;
}

/**
 * Coerce an untrusted money-ish value to a finite number, or null.
 * Accepts numbers and plain numeric strings (Firestore console edits /
 * CSV imports leave string-typed numbers behind). Anything else — NaN,
 * Infinity, '', objects — is null.
 */
export function toFiniteMoney(v: unknown): number | null {
  if (typeof v === 'number') return Number.isFinite(v) ? v : null;
  if (typeof v === 'string' && v.trim() !== '') {
    const n = Number(v.trim());
    return Number.isFinite(n) ? n : null;
  }
  return null;
}
